import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  gradient?: boolean;
  blur?: 'sm' | 'md' | 'lg' | 'xl';
}

export const GlassCard: React.FC<GlassCardProps> = ({
  children,
  className,
  hover = true,
  gradient = false,
  blur = 'md'
}) => {
  const blurClasses = {
    sm: 'backdrop-blur-sm',
    md: 'backdrop-blur-md',
    lg: 'backdrop-blur-lg',
    xl: 'backdrop-blur-xl'
  };

  return (
    <motion.div
      className={cn(
        'relative overflow-hidden rounded-2xl border border-white/20 dark:border-gray-700/30',
        'bg-white/10 dark:bg-gray-800/10',
        blurClasses[blur],
        'shadow-xl shadow-black/5 dark:shadow-black/20',
        gradient && 'bg-gradient-to-br from-white/20 via-white/10 to-transparent dark:from-gray-700/20 dark:via-gray-800/10',
        className
      )}
      whileHover={hover ? { 
        scale: 1.02, 
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
        borderColor: 'rgba(255, 255, 255, 0.3)'
      } : undefined}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      {/* Glass effect overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 via-transparent to-black/5 dark:from-white/5 dark:to-black/10 pointer-events-none" />
      
      {/* Inner glow */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/10 via-transparent to-transparent dark:from-white/5 pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </motion.div>
  );
};